import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import { IUserInfo } from 'kts-platform-frame/dataModel';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Form, Input, Button } from 'antd';
import Icon from 'kts-platform-frame/display/components/Icon';
import { create } from 'kts-scaffold-framework/utils/form';
import { Decorators } from 'kts-scaffold-framework/utils/doc';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    userInfo?: IUserInfo;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    userInfo: state.user.userInfo,
}))
export default class UIInfo extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        const { form } = this.props;
        const { getFieldDecorator } = form;
        return (
            <div className={css.ModalChangePhoneNum}>
                <div className={css.header}>
                    <div className={css.title}>修改手机号</div>
                    <div className={css.titleDes}>请输入新手机号</div>
                </div>
                <div className={css.content}>
                    <div>
                        <Form className={`${css.changePhoneForm} clear`}>
                            <Form.Item>
                                {getFieldDecorator('phone', {
                                    rules: [Decorators.phone()],
                                    initialValue: undefined
                                })(
                                    <Input
                                        placeholder="手机号码"
                                        prefix={<Icon className={css.inputIcon} color="#000" width={14} height={14} src={require('./img/img.phone.svg')} />}
                                    />
                                )}
                            </Form.Item>
                            
                            <Form.Item className={css.verificationInput}>
                                {getFieldDecorator('validateCode', {
                                    rules: [{ required: true, message: '验证码不能为空' }],
                                })(
                                    <Input
                                        placeholder="验证码"
                                        prefix={<Icon className={css.inputIcon} color="#000" width={14} height={14} src={require('./img/img.verification.svg')} />}
                                    />
                                )}
                                <div className={css.getVerification}>{this.getVerification()}</div>
                            </Form.Item>
                        </Form>
                    </div>
                    <div className={css.footerBt}>
                        <Button onClick={this.nextStep} className={css.nextBt}>确认修改</Button>
                        <Button onClick={ModulesAction.closeChangePhoneM} className={css.cancelBt}>取消</Button>
                    </div>
                                
                </div>
            </div>
        );
    }
    /** 验证显示模板 */
    private getVerification = () => {
        let {verificationCounter, validateSending} =  this.modulesState;
        if (validateSending){
            return <span className={css.sendCounter}>发送中...</span>;
        }
        if (verificationCounter <= 0) {
            return <a onClick={() => this.sendPhone()}>获取验证码</a>;
        } else {
            
            return <span className={css.sendCounter}>{verificationCounter}秒后重新发送</span>;
        }
        
    }
    /** 验证码发送到手机 */
    private sendPhone = () => {
        this.props.form.validateFields(['phone'], (err, val) => {
            if (!err) {
                ModulesAction.sendPhone(val);
            }
        });
    }
    
    /** 下一步 */
    private nextStep = () => {
        this.props.form.validateFields((err, val) => {
            if (!err) {
                ModulesAction.changePSD(val);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/UserCenter/UI.ChangePhone.tsx